import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";
import ExtraInfoButton from "./ExtraInfoButton";
import ExtraInfoModal from "./ExtraInfoModal";
import styles from "./ExtraInfoModal.module.scss";

type WhatMakesThisTourUniqueButtonProps = {
  content: string | null | undefined;
};

export default function WhatMakesThisTourUniqueButton({
  content,
}: WhatMakesThisTourUniqueButtonProps) {
  const [open, setOpen] = useState(false);
  const items = parseContent(content);

  if (items.length === 0) return <></>;

  return (
    <>
      <ExtraInfoButton
        label="What makes this tour unique"
        onClick={() => setOpen(true)}
      />
      <ExtraInfoModal
        open={open}
        title="What makes this tour unique"
        content={items.map((item, index) => (
          <div className={styles.item} key={`${item}-${index}`}>
            <CheckIcon className={styles.check} />
            <p className={styles.itemText}>{item}</p>
          </div>
        ))}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

function parseContent(content: string | null | undefined) {
  return (content ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}
